(() => {
  if (window.aldenoBespokeReady) return;
  window.aldenoBespokeReady = true;
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') { const menu = document.getElementById('aldeno-mobile-menu'); const toggle = document.querySelector('.aldeno-mobile-menu-toggle'); if (menu && !menu.hidden) { menu.hidden = true; toggle?.setAttribute('aria-expanded', 'false'); toggle?.focus(); } } });
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('.aldeno-mobile-menu-toggle');
    const menu = document.getElementById('aldeno-mobile-menu');
    if (toggle && menu) { menu.hidden = !menu.hidden; toggle.setAttribute('aria-expanded', String(!menu.hidden)); return; }
    if (menu && !menu.hidden && !event.target.closest('.aldeno-mobile-menu-toggle')) { menu.hidden = true; document.querySelector('.aldeno-mobile-menu-toggle')?.setAttribute('aria-expanded', 'false'); }

  });
})();

/* Keep large embedded artwork out of the initial network queue. */
(() => {
  if (window.aldenoArtworkReady) return;
  window.aldenoArtworkReady = true;
  const load = (img) => {
    const src = img.dataset.aldenoSrc;
    if (!src) return;
    img.closest('picture')?.querySelectorAll('[data-aldeno-srcset]').forEach(source => {
      source.srcset = source.dataset.aldenoSrcset;
      delete source.dataset.aldenoSrcset;
    });
    img.loading = 'eager';
    img.src = src;
    delete img.dataset.aldenoSrc;
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) { load(entry.target); observer.unobserve(entry.target); }
    });
  }, {rootMargin: '300px'}) : null;
  const scan = (root) => root.querySelectorAll('img[data-aldeno-src]').forEach(img => {
    if (observer) observer.observe(img); else load(img);
  });
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
